module.exports = __webpack_public_path__ + "static/media/Trash.f73dbb77.svg";